export enum ApiVersionedRoute {
  auth = 'v3/auth',
  dlci = 'v1',
  entity = 'v1',
  permissions = 'v1/permissions',
  reports = 'v1',
  scheduler = 'v1',
  secureData = 'v1',
  users = 'v1',
  chat = 'v3/chat',
  announcement = 'v1',
  newsfeed = 'v1',
  attachment = 'v1',
  featureFlags = 'v1/feature-flags',
  task_management = 'v2/task-management',
  housekeeping = 'v1/housekeeping',
}
